import React, { useState, useMemo } from "react";
import {v4 as uuidv4} from 'uuid'
import './styles/index'
import { CURRENT_CART_VERSION } from '../ShoppingCart/constants';
import { ICartItems, IPassenger, ITicket, IJEPTicketOrderItem } from '../ShoppingCart/types';
import { retrieveCartItems, storeCartItems } from '../ShoppingCart/helpers';
import t from "./helpers"
import {Field, Select, Button, Input, FieldGroup} from "./common";

// TODO: 交通APIから取得する
const nationalityOptions = [
  '',
  // 'ABW',
  'AFG',
  'AGO',
  'AIA',
  'ALA',
  'ALB',
  'AND',
  'ARE',
  'ARG',
  'ARM',
  'ASM',
  'ATA',
  'ATF',
  'ATG',
  'AUS',
  'AUT',
  'AZE',
  'BDI',
  'BEL',
  'BEN',
  'BES',
  'BFA',
  'BGD',
  'BGR',
  'BHR',
  'BHS',
  'BIH',
  'BLM',
  'BLR',
  'BLZ',
  'BMU',
  'BOL',
  'BRA',
  'BRB',
  'BRN',
  'BTN',
  'BVT',
  'BWA',
  'CAF',
  'CAN',
  'CCK',
  'CHE',
  'CHL',
  'CHN',
  'CIV',
  'CMR',
  'COD',
  'COG',
  'COK',
  'COL',
  'COM',
  'CPV',
  'CRI',
  'CUB',
  'CUW',
  'CXR',
  'CYM',
  'CYP',
  'CZE',
  'DEU',
  'DJI',
  'DMA',
  'DNK',
  'DOM',
  'DZA',
  'ECU',
  'EGY',
  'ERI',
  'ESH',
  'ESP',
  'EST',
  'ETH',
  'FIN',
  'FJI',
  'FLK',
  'FRA',
  'FRO',
  'FSM',
  'GAB',
  'GBR',
  'GEO',
  'GGY',
  'GHA',
  'GIB',
  'GIN',
  'GLP',
  'GMB',
  'GNB',
  'GNQ',
  'GRC',
  'GRD',
  'GRL',
  'GTM',
  'GUF',
  'GUM',
  'GUY',
  'HKG',
  'HMD',
  'HND',
  'HRV',
  'HTI',
  'HUN',
  'IDN',
  'IMN',
  'IND',
  'IOT',
  'IRL',
  'IRN',
  'IRQ',
  'ISL',
  'ISR',
  'ITA',
  'JAM',
  'JEY',
  'JOR',
  'JPN',
  'KAZ',
  'KEN',
  'KGZ',
  'KHM',
  'KIR',
  'KNA',
  'KOR',
  'KWT',
  'LAO',
  'LBN',
  'LBR',
  'LBY',
  'LCA',
  'LIE',
  'LKA',
  'LSO',
  'LTU',
  'LUX',
  'LVA',
  'MAC',
  'MAF',
  'MAR',
  'MCO',
  'MDA',
  'MDG',
  'MDV',
  'MEX',
  'MHL',
  'MKD',
  'MLI',
  'MLT',
  'MMR',
  'MNE',
  'MNG',
  'MNP',
  'MOZ',
  'MRT',
  'MSR',
  'MTQ',
  'MUS',
  'MWI',
  'MYS',
  'MYT',
  'NAM',
  'NCL',
  'NER',
  'NFK',
  'NGA',
  'NIC',
  'NIU',
  'NLD',
  'NOR',
  'NPL',
  'NRU',
  'NZL',
  'OMN',
  'PAK',
  'PAN',
  'PCN',
  'PER',
  'PHL',
  'PLW',
  'PNG',
  'POL',
  'PRI',
  'PRK',
  'PRT',
  'PRY',
  'PSE',
  'PYF',
  'QAT',
  'REU',
  'ROU',
  'RUS',
  'RWA',
  'SAU',
  'SDN',
  'SEN',
  'SGP',
  'SGS',
  'SHN',
  'SJM',
  'SLB',
  'SLE',
  'SLV',
  'SMR',
  'SOM',
  'SPM',
  'SRB',
  'SSD',
  'STP',
  'SUR',
  'SVK',
  'SVN',
  'SWE',
  'SWZ',
  'SXM',
  'SYC',
  'SYR',
  'TCA',
  'TCD',
  'TGO',
  'THA',
  'TJK',
  'TKL',
  'TKM',
  'TLS',
  'TON',
  'TTO',
  'TUN',
  'TUR',
  'TUV',
  'TWN',
  'TZA',
  'UGA',
  'UKR',
  'UMI',
  'URY',
  'USA',
  'UZB',
  'VAT',
  'VCT',
  'VEN',
  'VGB',
  'VIR',
  'VNM',
  'VUT',
  'WLF',
  'WSM',
  'YEM',
  'ZAF',
  'ZMB',
  'ZWE',
];

const genderOptions = [
  {
    value: 'Female',
    label: t.female()
  },
  {
    value: 'Male',
    label: t.male()
  }
];

const url = new URL(window.location.href);

const syncCart = () => {
  return new Promise<void>((resolve) => {
    setTimeout(() => { resolve(); }, 1000);
  });
};

export const JEP_NN = ({ticket}: {ticket: ITicket}) => {
  const [isLoading, setIsLoading] = useState(false)
  const [values, setValues] = useState({
    plan: ticket.plans[0], // planIdではなく、planを使う理由は、planの方が汎用性が高いこと（planId以外のplan関連情報も取得できるため）
    adults: [{
      id: uuidv4(),
      firstName: '',
      lastName: '',
      sex: genderOptions[0].value,
      nationality: '',
      birthDate: '',
    }],
    children: []
  })

  const agreedTotalAmount = useMemo(() => {
    return values.adults.length * values.plan.adultSellingPrice + values.children.length * values.plan.childSellingPrice
  }, [values.adults, values.children, values.plan.adultSellingPrice, values.plan.childSellingPrice])

  const handleChange = (event: React.ChangeEvent<HTMLSelectElement | HTMLInputElement>, id = null) => {
    setValues(prev => {
      if (event.target.name === 'plan') {
        return {
          ...prev,
          [event.target.name]: ticket.plans.find(p => p.planId === parseInt(event.target.value))
        }
      } else {
        const adult = values.adults.find(a => a.id === id)
        if (adult) {
          const updated = {
            ...adult,
            [event.target.name]: event.target.value
          }
          return {
            ...prev,
            adults: values.adults.map(a => a.id === adult.id ? updated : a)
          }
        } else {
          const child = values.children.find(c => c.id === id)
          const updated = {
            ...child,
            [event.target.name]: event.target.value
          }
          return {
            ...prev,
            children: values.children.map(c => c.id === child.id ? updated : c)
          }
        }
      }
    })
  }

  const handleClickAdd = (event, isAdult) => {
    if (isAdult) {
      setValues(prev => ({
        ...prev,
        adults: [...values.adults, {
          id: uuidv4(),
          firstName: '',
          lastName: '',
          sex: genderOptions[0].value,
          nationality: '',
          birthDate: '',
        }]
      }))
    } else {
      setValues(prev => ({
        ...prev,
        children: [...values.children, {
          id: uuidv4(),
          firstName: '',
          lastName: '',
          sex: genderOptions[0].value,
          nationality: '',
          birthDate: '',
        }]
      }))
    }
  }

  const handleClickRemove = (id, isAdult) => {
    if ([...values.adults, ...values.children].length === 1) return
    if (isAdult) {
      setValues(prev => ({
        ...prev,
        adults: values.adults.filter(a => a.id !== id)
      }))
    } else {
      setValues(prev => ({
        ...prev,
        children: values.children.filter(c => c.id !== id)
      }))
    }
  }

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault()
    if (isLoading) return
    setIsLoading(true)
    const prevCartItems: ICartItems = retrieveCartItems(CURRENT_CART_VERSION);

    const ticketOrderItem: IJEPTicketOrderItem = {
      ticketId: ticket.ticketId,
      planId: values.plan.planId,
      agreedTotalAmount,
      adults: values.adults,
      children: values.children,
      ticket
    }

    const cartItems = { ...prevCartItems, jepTicketOrderItems: [...(prevCartItems.jepTicketOrderItems || []), ticketOrderItem] };

    await syncCart();
    storeCartItems(cartItems)
    setIsLoading(false)
  }
  return (
    <form onSubmit={handleSubmit} noValidate>
      {/* plans */}
      <div className="price-calculator__section">
        <Field htmlFor='plan' label={t.price()}>
          <Select id='plan' name='plan' options={
            ticket.plans.map(({ planId, name, adultSellingPrice }) => ({ id: planId, value: planId, label: `${name} | JPY ${adultSellingPrice}` }))
          } value={values.plan.planId} onChange={(e) => setValues(prev => ({
            ...prev,
            plan: ticket.plans.find(p => p.planId === parseInt(e.target.value))
          }))} />
        </Field>
      </div>
      {/* adults */}
      {values.adults.map((p, i) => {
        return (
          <FieldGroup key={p.id} title={t.adult()} index={i + 1} handleRemove={() => handleClickRemove(p.id, true)}>
            <Field htmlFor='firstName' label={t.firstName()}>
              {/* TODO: 各言語のplaceholderに差し替える */}
              <Input
                id='firstName'
                name='firstName'
                placeholder='HONG'
                type='text'
                value={p.firstName}
                onChange={(event) => handleChange(event, p.id)}
              />
            </Field>
            <Field htmlFor='lastName' label={t.lastName()}>
              <Input
                id='lastName'
                name='lastName'
                placeholder='WANG'
                type='text'
                value={p.lastName}
                onChange={(event) => handleChange(event, p.id)}
              />
            </Field>
            <Field htmlFor='sex' label={t.sex()}>
              <Select
                id='sex'
                name='sex'
                options={genderOptions.map(({value, label}) => ({
                  id: value,
                  value,
                  label,
                }))}
                value={p.sex}
                onChange={(event) => handleChange(event, p.id)}
              />
            </Field>
            <Field htmlFor='nationality' label={t.nationality()}>
              <Select
                id='nationality'
                name='nationality'
                options={nationalityOptions.map((nationality) => ({
                  id: nationality,
                  value: nationality,
                  label: nationality,
                }))}
                value={p.nationality}
                onChange={(event) => handleChange(event, p.id)}
              />
            </Field>
            <Field htmlFor='birthDate' label={t.birthDate()}>
              <Input
                id='birthDate'
                name='birthDate'
                type='date'
                value={p.birthDate}
                onChange={(event) => handleChange(event, p.id)}
              />
            </Field>
          </FieldGroup>
        );
      })}
      {/* children */}
      {values.children.map((p, i) => {
        return (
          <FieldGroup key={p.id} title={t.child()} index={i + 1} handleRemove={() => handleClickRemove(p.id, false)}>
            <Field htmlFor='firstName' label={t.firstName()}>
              <Input id='firstName' name='firstName' placeholder='HONG' type='text' value={p.firstName} onChange={(event) => handleChange(event, p.id)} />
            </Field>
            <Field htmlFor='lastName' label={t.lastName()}>
              <Input id='lastName' name='lastName' placeholder='WANG' type='text' value={p.lastName} onChange={(event) => handleChange(event, p.id)} />
            </Field>
            <Field htmlFor='sex' label={t.sex()}>
              <Select
                id='sex'
                name='sex'
                options={genderOptions.map(({value, label}) => ({
                  id: value,
                  value,
                  label,
                }))}
                value={p.sex}
                onChange={(event) => handleChange(event, p.id)}
              />
            </Field>
            <Field htmlFor='nationality' label={t.nationality()}>
              <Select
                id='nationality'
                name='nationality'
                options={nationalityOptions.map((nationality) => ({
                  id: nationality,
                  value: nationality,
                  label: nationality,
                }))}
                value={p.nationality}
                onChange={(event) => handleChange(event, p.id)}
              />
            </Field>
            <Field htmlFor='birthDate' label={t.birthDate()}>
              <Input id='birthDate' name='birthDate' type='date' value={p.birthDate} onChange={(event) => handleChange(event, p.id)} />
            </Field>
          </FieldGroup>
        )
      })}
      <div
        className="price-calculator__section"
        style={{ display: "flex", justifyContent: "flex-end" }}
      >
        <Button
          type='button'
          onClick={(event) => handleClickAdd(event, true)}
          disabled={values.adults.length === 10}
          style={{border: 'none'}}
        >
          <span>
            <i
              className="fa fa-plus"
              aria-hidden="true"
              style={{ marginRight: "1px" }}
            ></i>
            追加成人
          </span>
        </Button>
        <Button
          type='button'
          onClick={(event) => handleClickAdd(event, false)}
          disabled={values.children.length === 10}
          style={{border: 'none'}}
        >
          <span>
            <i
              className="fa fa-plus"
              aria-hidden="true"
              style={{ marginRight: "1px" }}
            ></i>
            追加兒童
          </span>
        </Button>
      </div>
      {/* add-to-cart button */}
      <div className="price-calculator__cta">
        {/* snow-cart-button = gtmのカートインイベント用のクラス　*/}
        {/* TODO: クラス以外の方法でトリガーする */}
        <Button type="submit" className="snow-cart-button">
          {t.addToCart()}
        </Button>
      </div>
    </form>
  )
}
